export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary-500/40 via-transparent to-transparent"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-12 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-400 tracking-wider">
                海量资源 · 每日更新 · 高清流畅
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
              天堂影院
              <br />
              <span className="text-primary-500">免费高清影视在线播放平台</span>
            </h1>

            <p className="mt-4 md:mt-5 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              汇集海量电影、电视剧、综艺动漫等影视资源，每日同步更新最新院线大片与热门剧集。
              无需注册、无广告打断，高清画质流畅播放，为您打造极致在线观影体验。
            </p>

            <div className="mt-6 md:mt-7 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 text-sm text-foreground-500">
              <div className="flex items-center gap-1.5">
                <i className="ri-movie-2-line text-primary-400 text-base"></i>
                <span>覆盖<strong className="text-foreground-800 font-semibold">10万+</strong>影视资源</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-timer-flash-line text-primary-400 text-base"></i>
                <span>每日<strong className="text-foreground-800 font-semibold">同步更新</strong>最新内容</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-shield-check-line text-primary-400 text-base"></i>
                <span>全站<strong className="text-foreground-800 font-semibold">高清流畅</strong>不缓冲</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto px-8 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all duration-200 whitespace-nowrap text-center"
              >
                开始观影
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 rounded-md border border-background-300/60 hover:border-primary-500/50 text-foreground-700 hover:text-primary-400 font-medium text-sm transition-all duration-200 whitespace-nowrap text-center"
              >
                热门榜单
                <i className="ri-fire-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-lg overflow-hidden bg-background-100 border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20atmosphere%20with%20warm%20golden%20spotlight%20illuminating%20floating%20film%20strips%20and%20celluloid%20ribbons%2C%20abstract%20geometric%20composition%20with%20deep%20charcoal%20background%2C%20subtle%20lens%20flare%2C%20elegant%20marquee%20light%20reflections%2C%20warm%20amber%20and%20crimson%20color%20gradients%2C%20atmospheric%20cinematic%20mood%2C%20no%20text%20no%20people&width=960&height=720&seq=hero-cinema-2026&orientation=landscape"
                alt="天堂影院 - 在线观影氛围"
                className="w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-background-50/40 via-transparent to-transparent lg:bg-gradient-to-r lg:from-background-50/30 lg:via-transparent lg:to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}